import { Layout, Card, Tabs, message } from "antd";
import { PageContainer } from "@ant-design/pro-components";
import { useEffect } from "react";
import { changePageTitle } from "../../utils/title";
import { SuppliesProvider } from "./context/SuppliesContext";
import AllApplications from "./components/AllApplications";
import PurchasePlan from "./components/PurchasePlan";
import Purchased from "./components/Purchased";
import WarehouseTab from "./components/WarehouseTab";
import Statistics from "./components/Statistics";

const { TabPane } = Tabs;

// Настройка положения уведомлений, чтобы не перекрывали выбор
message.config({
  top: 100,
  placement: 'topRight',
});

const Supplies = () => {
  useEffect(() => {
    changePageTitle("Снабжения");
  }, []);

  return (
    <SuppliesProvider>
      <Layout>
        <PageContainer
          title="Снабжения"
          style={{ maxHeight: "100vh" }}
        >
          <Card
            style={{ borderRadius: 8 }}
            bodyStyle={{ padding: "0 16px 16px 16px" }}
          >
            <Tabs
              defaultActiveKey="ALL"
              size="large"
              type="card"
              tabBarStyle={{ marginBottom: 0 }}
              destroyInactiveTabPane
            >
              <TabPane tab="Все заявки" key="ALL">
                <AllApplications />
              </TabPane>
              <TabPane tab="План закупок" key="PLAN">
                <PurchasePlan />
              </TabPane>
              <TabPane tab="Закуплено" key="PURCHASED">
                <Purchased />
              </TabPane>
              <TabPane tab="Склад" key="WAREHOUSE">
                <WarehouseTab />
              </TabPane>
              <TabPane tab="Статистика" key="STATS">
                <Statistics />
              </TabPane>
            </Tabs>
          </Card>
        </PageContainer>
      </Layout>
    </SuppliesProvider>
  );
};

export default Supplies;

